"use strict";

var diagnostics = {
  trace: trace,
  enabled: false,
  devtoolsEnabled: false
};

module.exports = diagnostics;

function trace() {
  if (diagnostics.enabled) {
    console && console.log.apply(console, arguments);
  }
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/core/diagnostics.js
 ** module id = 229
 ** module chunks = 0
 **/